import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const BASE = `${u}/habits`;

export const listHabits   = async () => { const r = await apiFetch(BASE); return r.ok ? r.json() : []; };
export const createHabit  = async (d) => { const r = await apiFetch(BASE, { method: "POST", body: JSON.stringify(d) }); return r.json(); };
export const updateHabit  = async (id, d) => { const r = await apiFetch(`${BASE}/${id}`, { method: "PUT", body: JSON.stringify(d) }); return r.json(); };
export const deleteHabit  = async (id) => apiFetch(`${BASE}/${id}`, { method: "DELETE" });
export const checkIn      = async (id, note = "") => { const r = await apiFetch(`${BASE}/${id}/check-in?note=${encodeURIComponent(note)}`, { method: "POST" }); return r.json(); };
export const uncheckIn    = async (id) => { const r = await apiFetch(`${BASE}/${id}/check-in`, { method: "DELETE" }); return r.json(); };
